<template>
    <div class="coupons-list-warp">
        <div class="coupons-list-tabs">
            <div :class="['coupons-list-tabs-item', activeType == 1 ? 'active' : '']" @click="changeType(1)">未使用<span></span></div>
            <div :class="['coupons-list-tabs-item', activeType == 2 ? 'active' : '']" @click="changeType(2)">已使用<span></span></div>
        </div>
        <div class="coupons-list-content">
            <div :class="['coupons-list-item', item.use_flag == 2 ? 'disabled' : '']" v-for="item in couponsList" :key="item.id">
                <div class="coupons-list-item-infoBox">
                    <div class="coupons-list-item-infoBox-left">
                        <label>{{ item.name }}</label>
                        <span v-if="item.end_time">有效期<br/>{{ fomatterDate(item.start_time) }}至{{ fomatterDate(item.end_time) }}</span>
                    </div>
                    <div class="coupons-list-item-infoBox-right">
                        <label>可抵扣{{ item.discount_amount / 100 }}元</label>
                        <span>满{{ item.target_amount / 100 }}减{{ item.discount_amount / 100 }}元券</span>
                    </div>
                </div>
                <div class="coupons-list-item-btn-box" v-if="item.use_flag == 1">
                    <div class="coupons-list-item-btn" @click="checkUse(item)">门店核销</div>
                </div>
            </div>
            <Empty v-if="!couponsList.length" :description="'暂无' + (activeType == 1 ? '可用' : '已用') +'优惠券'" />
            <div v-if="!couponsList.length && activeType == 1 && showGetCoupons" class="coupons-get-btn">
                <van-button plain type="info" @click="goGetCoupons">立刻领券</van-button>
            </div>
        </div>
        <Loading v-if="isLoading"/>
    </div>
</template>
<script>
import { getCouponsList, showCouponsFlag, useCoupons } from '../api/index.js'
import Loading from '../components/loaddingCom'
import { Empty, Dialog, Toast } from 'vant';
export default {
    data() {
        return {
            couponsList: [],
            activeType: 1,
            isLoading: false,
            showGetCoupons: false
        }
    },
    components: { Empty, Loading },
    activated() {
        this.showCouponsFlag()
        this.getcouponsList(this.activeType)
    },
    methods: {
        showCouponsFlag() {
            showCouponsFlag().then(res => {
                console.log('showCouponsFlag', res)
                if(res.data == 1) {
                    this.showGetCoupons = true
                }
            })
        },
        getcouponsList(e) {
            let data = {
                page: 1,
                page_size: 100,
                use_flag: e,
                expire_flag: 0
            }
            this.isLoading = true
            getCouponsList(data).then(res => {
                console.log('getcouponsList=======>', res)
                if (res.message == 'success') {
                    let list = res.data.data || []
                    this.couponsList = list
                }
                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
            })
        },
        changeType(e) {
            this.activeType = e
            this.getcouponsList(e)
        },
        goGetCoupons() {
            this.$router.push({ path: '/getCoupons' })
        },
        checkUse(e) {
            Dialog.confirm({
                title: '使用优惠券',
                message: '此页面使用优惠券需在门店店员的引导下，在门店中消费使用，使用后无法撤销，是否确定使用？',
            })
            .then(() => {
                this.isLoading = true
                useCoupons({use_flag: 2, user_coupon_id: e.user_coupon_id}).then(res => {
                    this.isLoading = false
                    if(res.message == 'success') {
                        Toast('已成功使用！')
                        this.getcouponsList(this.activeType);
                    }
                }).catch(() => {
                    this.isLoading = false
                })
            })
        },
        fomatterDate(e){
            if (e) {
                return e.split('T')[0]
            } else {
                return e
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.coupons-list-warp {
    background: #f9f9f9;
    .coupons-list-tabs {
        display: flex;
        justify-content: center;
        align-items: center;
        .coupons-list-tabs-item {
            width: 80px;
            margin: 0 20px;
            font-size: 14px;
            font-weight: 400;
            color: #999;
            text-align: center;
            line-height: 44px;
            &.active {
                font-weight: 500;
                color: #000;
                position: relative;
                > span {
                    display: block;
                    width: 20px;
                    height: 3px;
                    border-radius: 2px;
                    background: #08aef9;
                    position: absolute;
                    bottom: 6px;
                    left: 50%;
                    margin-left: -10px;
                }
            }
        }
    }
    .coupons-list-content {
        .coupons-list-item {
            padding: 16px;
            background: #f96a38;
            border-radius: 8px;
            margin-bottom: 16px;
            box-sizing: border-box;
            .coupons-list-item-infoBox {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 16px;
                .coupons-list-item-infoBox-left {
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    max-width: 55%;
                    label {
                        font-size: 16px;
                        font-weight: 500;
                        color: #fff;
                        margin-bottom: 10px;
                    }
                    span {
                        font-size: 12px;
                        font-weight: 400;
                        color: #fff;
                    }
                }
                .coupons-list-item-infoBox-right {
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    align-items: flex-end;
                    label {
                        font-size: 12px;
                        font-weight: 400;
                        color: #fff;
                        margin-bottom: 6px;
                        text-align: right;
                    }
                    span {
                        font-size: 20px;
                        font-weight: 600;
                        color: #fff;
                        text-align: right;
                    }
                }
            }
            .coupons-list-item-btn-box {
                height: 20px;
                width: 100%;
                .coupons-list-item-btn {
                    background: #fff;
                    color: #08aef9;
                    width: 64px;
                    height: 24px;
                    border-radius: 4px;
                    line-height: 24px;
                    text-align: center;
                    font-size: 12px;
                    float: right;
                }
            }
            &.disabled {
                background: #fff;
                .coupons-list-item-infoBox {
                    .coupons-list-item-infoBox-left {
                        label {
                            color: #999;
                        }
                        span {
                            color: #999;
                        }
                    }
                    .coupons-list-item-infoBox-right {
                        label {
                            color: #999;
                        }
                        span {
                            color: #999;
                        }
                    }
                }
                .coupons-list-item-btn-box {
                    .coupons-list-item-btn {
                        background: #fff;
                        color: #999;
                        pointer-events: none;
                    }
                }
            }
            .coupons-list-item-ruleBox {
                display: flex;
                justify-content: space-between;
                padding-top: 10px;
                span {
                    font-weight: 400;
                    font-size: 12px;
                    color: #999;
                    flex-grow: 1;
                }
                div {
                    width: 90px;
                    border: 1px solid #08aef9;
                    color: #08aef9;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 24px;
                    text-align: center;
                    border-radius: 15px;
                    &.disabled {
                        border-color: #999;
                        color: #999;
                        pointer-events: none;
                    }
                }
            }
        }
        .coupons-get-btn {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
